

import _uniq from 'lodash/uniq'
import { TLoadable, isLoaded, createLoaded } from "../../../sg-core";

interface IItemToMappedIdListResponse<T> {
    mapping: {
        [id: number]: T,
    },
    ids: (number)[],
}

/**
 * Creates id mapping and list of ids for items.
 * @param items 
 */
export function itemsToMappedIdList<T extends { id: number }>(items: T[], key: keyof T = "id"): IItemToMappedIdListResponse<T> {
    const initial = { mapping: {}, ids: [] };

    const parsed = items.reduce<IItemToMappedIdListResponse<T>>((acc, item) => {
        const itemsKey = item[key] as any
        return {
            mapping: { ...acc.mapping, [itemsKey]: item },
            ids: acc.ids.concat(itemsKey),
        };
    }, initial);

    return parsed;
}

/**
 * Combines id lists to new loaded list with only unique items.
 */
export const appendUniqueToLodableIdList = (lodableList: TLoadable<number[]>, newIds: number[]): TLoadable<number[]> => {
    if (isLoaded(lodableList) && newIds.length) {
        return createLoaded(_uniq(lodableList.data.concat(newIds)))
    } else if (newIds.length) {
        return createLoaded(newIds)
    }
    return lodableList
}